export default __webpack_public_path__ + "static/media/TERMOS-DE-USO-DA-AREA-DE-CLIENTE-vf.76a5acd2.pdf";